module.exports = __webpack_public_path__ + "images/emoji/feelsgood.fb4e5e64156626a64193.png";